import React, { useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PageTitle from "../layouts/PageTitle";

const usersList = [
  { id: 1, name: "User 1" },
  { id: 2, name: "User 2" },
  { id: 3, name: "User 3" },
  { id: 4, name: "User 4" },
  { id: 5, name: "User 5" },
  { id: 6, name: "User 6" },
  { id: 7, name: "User 7" },
  { id: 8, name: "User 8" },
];

const NotificationForm = () => {
  const initialValues = {
    title: "",
    users: [],
    description: "",
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    users: Yup.array().min(1, "Please select at least one user"),
    description: Yup.string()
      .min(1, "Description must be at least 1 character")
      .max(30, "Description cannot exceed 20 characters")
      .required("Description is required"),
  });

  const handleSubmit = (values) => {
    console.log("Form Data:", values);
  };

  return (
    <div className="qx-page">
      <PageTitle pageTitle="Send Notification" subtitle="Send push notifications to selected users" />

      <div className="qx-section-card">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className="mb-3">
                <label className="form-label">Title</label>
                <Field type="text" name="title" className="form-control" />
                <ErrorMessage name="title" component="div" className="text-danger small mt-1" />
              </div>

              <div className="mb-3">
                <label className="form-label">Users</label>
                <div className="d-flex flex-wrap gap-2">
                  {usersList.map((user) => (
                    <label key={user.id} className="form-check-label d-flex align-items-center gap-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={values.users.includes(user.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setFieldValue("users", [...values.users, user.id]);
                          } else {
                            setFieldValue(
                              "users",
                              values.users.filter((id) => id !== user.id),
                            );
                          }
                        }}
                      />
                      {user.name}
                    </label>
                  ))}
                </div>
                <ErrorMessage name="users" component="div" className="text-danger small mt-1" />
              </div>

              <div className="mb-4">
                <label className="form-label">Description</label>
                <Field as="textarea" name="description" className="form-control" rows={4} />
                <ErrorMessage name="description" component="div" className="text-danger small mt-1" />
              </div>

              <div className="d-flex justify-content-end">
                <button type="submit" className="btn btn-primary qx-btn-brand">
                  Send Notification
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default NotificationForm;
